import { Injectable } from '@angular/core'

import { ExposureDebuggingObject } from '../types/debugging.type'

@Injectable({
	providedIn: 'root',
})
export class DebuggingService {
	exposureDebuggingObject: Record<string, ExposureDebuggingObject> = {}

	isModalOpen = false

	alertMessage = ''

	showDebuggingAlert(alertMessage: string): void {
		// This updates the alertMessage to the alertMsg passed into the function
		this.alertMessage = alertMessage
		this.isModalOpen = true
	}

	// This updates the showsAlert behavior subject to 'false'
	dismissDebuggingAlert(): void {
		this.isModalOpen = false
	}

	removeExposureDebuggingObject(key: string): void {
		if (this.exposureDebuggingObject[key]) {
			delete this.exposureDebuggingObject[key]
		}
	}
}
